import { render, staticRenderFns } from "./ListItemCarriers.vue?vue&type=template&id=2797b67e"
import script from "./ListItemCarriers.vue?vue&type=script&lang=js"
export * from "./ListItemCarriers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports